import { render, staticRenderFns } from "./auth-form-input-text.vue?vue&type=template&id=28d9f860&scoped=true&"
import script from "./auth-form-input-text.vue?vue&type=script&lang=js&"
export * from "./auth-form-input-text.vue?vue&type=script&lang=js&"
import style0 from "./auth-form-input-text.vue?vue&type=style&index=0&id=28d9f860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d9f860",
  null
  
)

export default component.exports